import { QueryKey, UseQueryOptions, useQuery } from 'react-query';

import { getSearch } from 'services/people';

export default function usePeopleSearch(
  term: string,
  teaming?: boolean,
  exclude_uuids?: string[],
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    [`people-search`, term, teaming, exclude_uuids],
    () =>
      getSearch(term, teaming, exclude_uuids).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
